import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardContent, CardLink } from "@sprout/client-components/dist/Card";
import { Flex, Text } from "sprout-ui-primitives";
import { Button } from "sprout-ui-dom/dist/Button";
import { Close as BaseClose } from "sprout-ui-icons";
import styled from "styled-components";
const CancelButton = styled(Button)`
  width: 24px;
  height: 24px;
  margin-right: -4px;
  margin-left: 4px;
`;
const Close = styled(BaseClose)`
  width: 18px;
  height: 18px;
`;
const PostPageHeaderCancellableButton = (props)=>{
    const { to , icon , label , onClick  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        position: "relative",
        px: 1,
        bg: "white.100",
        borderRadius: "8px",
        children: [
            /*#__PURE__*/ _jsx(CardLink, {
                to: to
            }),
            /*#__PURE__*/ _jsxs(CardContent, {
                as: Flex,
                alignItems: "center",
                minHeight: "32px",
                py: 0,
                children: [
                    icon,
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        fontWeight: "medium",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx(CancelButton, {
                        variant: "circle",
                        onClick: onClick,
                        children: /*#__PURE__*/ _jsx(Close, {})
                    })
                ]
            })
        ]
    });
};
export default PostPageHeaderCancellableButton;
